import { IBonusTier } from "../CommissionMatrix/types";

export interface TabModel {
	setupId: string;
	key: string;
	label: string;
	tiers: IBonusTier[];
	valid: boolean;
	evaluationType: string;
}

export interface VariableOperationsGpsBonusModel {
	tabs: TabModel[];
	globalUnitCounts: boolean;
	combineFranchises: boolean;
}

export enum TabKey {
	NEW_VEHICLES = "newVehicles",
	PRE_OWNED = "preOwned",
	COMBINED = "combined",
}

export enum SwitchKey {
	COMBINE_FRANCHISES = "combineFranchises",
	GLOBAL_UNIT_COUNTS = "globalUnitCounts",
}
